import {Component, Input} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';

@Component({
    selector: 'app-work-rotation-element-form',
    templateUrl: './work-rotation-element-form.component.html',
    styleUrls: ['./work-rotation-element-form.component.scss']
})
export class WorkRotationElementFormComponent {

    @Input() label: string;
    @Input() form: UntypedFormGroup;

    get isDayOff(): boolean {
        const { startTime, endTime } = this.form.value;
        return !startTime && !endTime;
    }

    clearForm() {
        this.form.reset({ startTime: null, endTime: null, breakTime: 0, unpaidBreakTime: 0, workingHours: 0 });
        this.form.markAsDirty();
    }
}
